import React, { useEffect } from "react";
import { Indicators, PVSyst, PostUsina, Usina } from "../types";
import { Cluster } from "../../clusters/types";
import { clustersApi } from "../../../services/api";

type UsinasContextType = {
  pvSyst: PVSyst | null;
  setPVSyst: (pvSyst: PVSyst | null) => void;
  newUsina: PostUsina | null;
  setNewUsina: (usina: PostUsina | null) => void;
  usina: Usina | null;
  setUsina: (usina: Usina | null) => void;
  currentUsina: Usina | null;
  setCurrentUsina: (usina: Usina | null) => void;
  currentIndicators?: Indicators;
  setCurrentIndicators: (indicators: Indicators | undefined) => void;
  clusters?: Cluster[];
  setClusters: (clusters: Cluster[]) => void;
};

const defaultValue: UsinasContextType = {
  pvSyst: null,
  setPVSyst: () => { },
  newUsina: null,
  setNewUsina: () => { },
  usina: null,
  setUsina: () => { },
  currentUsina: null,
  setCurrentUsina: () => { },
  currentIndicators: undefined,
  setCurrentIndicators: () => { },
  clusters: undefined,
  setClusters: () => { },
};

export const UsinasContext = React.createContext(defaultValue);

export default function UsinasContextProvider(props: {
  children: React.ReactNode;
}) {
  const [usina, setUsina] = React.useState<Usina | null>(null);
  const [newUsina, setNewUsina] = React.useState<PostUsina | null>(null);
  const [currentUsina, setCurrentUsina] = React.useState<Usina | null>(null);
  const [pvSyst, setPVSyst] = React.useState<PVSyst | null>(null);
  const [currentIndicators, setCurrentIndicators] = React.useState<
    Indicators | undefined
  >(undefined);
  const [clusters, setClusters] = React.useState<Cluster[]>([]);

  const getClusters = async () => {
    const result = await clustersApi.getClusters()
    setClusters(result.data)
  }

  useEffect(() => {
    getClusters()
  }, []);

  return (
    <UsinasContext.Provider
      value={{
        pvSyst,
        setPVSyst,
        newUsina,
        setNewUsina,
        usina,
        setUsina,
        currentUsina,
        setCurrentUsina,
        currentIndicators,
        setCurrentIndicators,
        clusters,
        setClusters,
      }}
    >
      {props.children}
    </UsinasContext.Provider>
  );
}
